module.exports = __webpack_public_path__ + "static/img/locked.31c9982.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/locked.png
// module id = DZpS
// module chunks = 134